module.exports = __webpack_public_path__ + "static/media/CC-BY-NC-SA.982c5314.png";